<template>
  <vue-recaptcha
    v-if="showRecaptcha"
    ref="vueRecaptcha"
    :sitekey="siteKey"
    @verify="recaptchaVerified"
    @expire="recaptchaExpired"
    @fail="recaptchaFailed"
  >
  </vue-recaptcha>
</template>

<script>
import { useIsInIframe } from "@/composables/useIsInIframe";
import vueRecaptcha from "vue3-recaptcha2";

export default {
  name: "App",
  components: {
    vueRecaptcha,
  },
  setup() {
    const isInIframe = useIsInIframe();
    return { isInIframe: isInIframe };
  },
  data() {
    return {
      siteKey: "6LeWnjMlAAAAABcLkOkNdEJtlpAvzB65b4_kuNml",
      //local: 6LdZVDYlAAAAAFusTmJy_ugSTQb1LBx5Ps9oFOGq
      //live & staging: 6LeWnjMlAAAAABcLkOkNdEJtlpAvzB65b4_kuNml
    };
  },
  methods: {
    recaptchaVerified(response) {
      this.$emit("valid", response);
      //console.log(response)
    },
    recaptchaExpired() {
      this.$refs.vueRecaptcha.reset();
    },
    recaptchaFailed() {
      console.error("Captch Failed 🛠️");
    },
  },
};
</script>
